import { getToolkitPropertyFieldDisplay } from '@aloft/toolkit-shared';

import { systemAccessorTPColumnDefs } from '../systemAccessorTPColumnDefs';
import { SystemAccessorTPColumnKey, TPColumnKey, isSystemAccessorTPColumnKey } from '../types';

export function getHeader(column: TPColumnKey | SystemAccessorTPColumnKey): string {
  return isSystemAccessorTPColumnKey(column)
    ? systemAccessorTPColumnDefs[column].title
    : getToolkitPropertyFieldDisplay(column);
}
